import type {SidebarLink} from '@github-ui/saved-views'

interface HandleNavItemClickParams {
  dashboardType: string
  linkItem: SidebarLink
  onSelectLink: (linkItem: SidebarLink) => void
  sendAnalyticsEvent: (category: string, action: string, label?: Record<string, unknown>) => void
}

// Handles the click on a navigation item, sending an analytics event and updating the query if it's a soft navigation.
export function getHandlerNavItemClick({dashboardType, linkItem, sendAnalyticsEvent}: HandleNavItemClickParams) {
  const tags = linkItem.source === 'predefined' ? {id: linkItem.id} : {shortcut: true}

  return () => {
    sendAnalyticsEvent(`${dashboardType}.click`, 'SIDEBAR_LINK', tags)
  }
}
